export default { 
    path: '*', 
    redirect: {
        name: '404'
    },
    meta: { 
        name: '', 
        title: '', 
        usedInMenu: false,
        icon: false,
        slug: {
            name: 'all',
            type: 'read'
        }
    } 
}


// WEBPACK FOOTER //
// ./src/router/modules/redirect.js